import {useEffect} from 'react'

import {useSelector, dispatch} from '../../store.js'
import {PACK_SHIP_PAGE} from '../../common/constants/Pages.js'
import {setCurrentPage} from '../../redux/actions/ui/index.js'
import {locationSelector} from '../../redux/selectors/ui/location.js'
import {PACK_SHIP_URI_COMPONENT} from './packShipFunctions.js'

export default function PackShipLocationListener() {
  const {
    pathComponents: [resource],
  } = useSelector(locationSelector)

  const isThisPage = resource === PACK_SHIP_URI_COMPONENT

  useEffect(() => {
    if (!isThisPage) {
      return
    }

    dispatch(setCurrentPage(PACK_SHIP_PAGE))
  }, [isThisPage])

  return null
}
